import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "@/lib/auth";
import "./login.css";

const Login: React.FC = () => {
	const navigate = useNavigate();
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState<string | null>(null);

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		const session = login(username, password);
		if (session) {
			navigate("/chat");
		} else {
			setError("Invalid username or password.");
		}
	};

	return (
		<div className="login-wrapper">
			<form className="login-card" onSubmit={handleSubmit}>
				<img
					className="login-logo"
					src="/assets/static/hatchdamh_small.png"
					alt="Hatch Institute"
				/>
				<h1 className="login-title">Clinician Portal</h1>
				<p className="login-subtitle">
					Sign in to access the training simulation.
				</p>

				<div className="login-field">
					<label htmlFor="username">Username</label>
					<input
						id="username"
						type="text"
						autoComplete="username"
						value={username}
						onChange={(e) => setUsername(e.target.value)}
						placeholder="admin"
					/>
				</div>

				<div className="login-field">
					<label htmlFor="password">Password</label>
					<input
						id="password"
						type="password"
						autoComplete="current-password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						placeholder="••••"
					/>
				</div>

				{error && <div className="login-error">{error}</div>}

				<button type="submit" className="login-button">
					Sign In
				</button>

				<div className="login-hint">
					<span>Demo credentials:</span>
					<code>admin</code> / <code>demo</code>
				</div>
			</form>
		</div>
	);
};

export default Login;
